export default __webpack_public_path__ + "static/AvenirLTStd-Roman-4087742a8e566b4f015c0a9f9c9bfb0f.woff2";